import {DetectionArea} from 'src/services/api'
import {Detection, Dim} from '../types/generics/ImageDetections'

export function isNormalizedDemarcatedCoordinates(startX: number, endX: number, startY: number, endY: number): boolean {
  const values = [startX, endX, startY, endY].map((value) => Number(value))

  if (values.some((value) => Number.isNaN(value))) {
    return false
  }

  return values.every((value) => value >= 0 && value <= 1)
}

export function resolveDetectionToPixels(detection: Detection, imageDim: Dim): Detection {
  const {x, y, width, height} = detection

  if (!isNormalizedDemarcatedCoordinates(x, width, y, height)) {
    return detection
  }

  if (imageDim.width <= 0 || imageDim.height <= 0) {
    return detection
  }

  return {
    ...detection,
    x: x * imageDim.width,
    y: y * imageDim.height,
    width: width * imageDim.width,
    height: height * imageDim.height,
  }
}

export function demarcatedAreaToDetection(area: DetectionArea): Detection {
  return {
    x: Number(area.startX),
    y: Number(area.startY),
    width: Number(area.endX),
    height: Number(area.endY),
    data: area,
  }
}
